"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitPerustetaanRavintola = void 0;
const Cookies = require("js-cookie");
const isNumber = (value) => typeof value === 'number';
function InitPerustetaanRavintola() {
    window.updateFormStepTip = (index, title, desc) => {
        let bubble = $('.bubble');
        let intro = bubble.find('.intro');
        let tips = bubble.find('.tips');
        if (title) {
            if (index == -1) {
                intro.find(' h3').text(title);
                let bubbleSpan = intro.find('span');
                bubbleSpan.text(desc);
                bubble.show();
                bubbleSpan.append($('<br>'))
                    .append($('<br>'))
                    .append($('<b>').text('KLIKKAA TÄSTÄ!'));
            }
            else {
                bubble.attr('data-index', index);
                tips.find('h3').text(title);
                tips.find('span').text(desc);
                let tipsRead = Cookies.get("tipsRead") || '';
                let tipIds = tipsRead.split(',');
                if ($('.bubble').is(":visible")) {
                    bubble.closest('.chatButton').removeClass('unread');
                    //.indexOf(valueToCheck) !== -1
                    if (tipIds.indexOf('' + index) == -1) {
                        tipIds.push(index);
                    }
                    Cookies.set("tipsRead", tipIds.join(','), { path: '/' });
                }
                else {
                    if (tipIds.indexOf('' + index) == -1) {
                        bubble.closest('.chatButton').addClass('unread');
                    }
                }
            }
        }
    };
    const PRCustomNavigationScripts = () => {
        let isStartPage = (jQuery('body.perustetaanravintola.StartPage').length === 1);
        //console.log('isStartPage', isStartPage);
        let scrollTop = jQuery(window).scrollTop();
        let navigationHeight = jQuery('.pr-navigation-wrapper').height();
        // Navigation top position
        let windowHeight = jQuery(window).innerHeight();
        if (isStartPage && (scrollTop < (windowHeight - navigationHeight))) {
            jQuery('.pr-navigation-wrapper').css('position', 'absolute').css('bottom', 0).css('top', 'auto');
            jQuery('.pr-navigation-wrapper').addClass('top');
        }
        else {
            jQuery('.pr-navigation-wrapper').css('position', 'fixed').css('top', 0).css('bottom', 'auto');
            jQuery('.pr-navigation-wrapper').removeClass('top');
        }
        jQuery('.pr-navigation li a').each(function () {
            let anchorId = "#" + jQuery(this).data('anchor');
            let anchorTop = jQuery(anchorId).position().top;
            if ((scrollTop + navigationHeight) > anchorTop) {
                jQuery(this).parent('li').addClass('active');
            }
            else {
                jQuery(this).parent('li').removeClass('active');
            }
        });
    };
    const VideoImageContentBlockScripts = () => {
        let navigationHeight = jQuery('.pr-navigation-wrapper').height();
        let scrollTop = jQuery(window).scrollTop();
        let closestElem = $('.video-image-content-block').filter(function () {
            return (jQuery(this).position().top <= (scrollTop + navigationHeight) && (jQuery(this).position().top + jQuery(this).height()) >= (scrollTop + navigationHeight * 4));
        });
        if (jQuery(closestElem).length > 0) {
            let containerWidth = (jQuery(window).innerWidth() < 1400) ? jQuery('.o-50-50-image').width() : 782;
            jQuery(closestElem).children('.o-50-50-image').children('.o-video-container').css('position', 'fixed').css('width', '100%').css('max-width', containerWidth + 'px').css('top', navigationHeight + 'px');
            jQuery(closestElem).children('.o-50-50-image').children('.imgContainer').css('position', 'fixed').css('width', '100%').css('max-width', containerWidth + 'px').css('top', navigationHeight + 'px');
        }
        else {
            jQuery('.o-video-container').css('position', 'relative').css('width', 'auto').css('max-width', '782px').css('top', 'auto');
            jQuery('.imgContainer').css('position', 'relative').css('width', 'auto').css('max-width', '782px').css('top', 'auto');
            jQuery('.o-video-thumbnail').show();
        }
    };
    jQuery(window).scroll(function () {
        PRCustomNavigationScripts();
        if (jQuery(window).innerWidth() >= 768) {
            VideoImageContentBlockScripts();
        }
    });
    jQuery('.play-video').on('click', function () {
        let windowWidth = jQuery(window).innerWidth();
        let videoHeight = jQuery(this).parents('.o-50-50-image').innerHeight() - 30;
        if (windowWidth < 768) {
            jQuery(this).parents('.o-video-container').addClass('relative');
        }
        jQuery(this).parents('.o-video-container').css('height', videoHeight + 'px');
        jQuery(this).parents('.o-video-thumbnail').show();
    });
    // init
    PRCustomNavigationScripts();
    jQuery('.pr-navigation-wrapper').css('visibility', 'visible'); // Set hidden in styles
    if (jQuery(window).innerWidth() >= 768) {
        VideoImageContentBlockScripts();
    }
    $('.pr-navigation li a').on('click', function (event) {
        //console.log('test')
        event.preventDefault();
        //console.log('$(this).attr(href)', $(this).attr('href'));
        let navigationHeight = jQuery('.pr-navigation-wrapper').height() - 3;
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - navigationHeight
        }, 300);
    });
    //jQuery('.pr-navigation li a').click(function () {
    //    $("html, body").animate({ scrollTop: 0 }, "slow");
    //})
    //$(document).ready(function () {
    //    $('html,body').animate({ scrollTop: $(location.hash).offset().top }, 500);
    //});
    //function smoothScrollingTo(target) {
    //    $('html,body').animate({ scrollTop: $(target).offset().top }, 500);
    //}
    if ($('body').hasClass('perustetaanravintola')) {
        let lomake = $('[data-block-type="formcontainerblock"]');
        if (lomake.length) {
            // THIS PORTION IS EXECUTED ON THE FORM PAGE ONLY!!!
            $('body').addClass('lomakePage');
            let images = $('.FormChoice--Image__Item img');
            images.each(function () {
                let image = $(this);
                let clone = image.clone();
                let src = image.attr('src');
                if (src.indexOf('empty.png') > 0) {
                    image.closest('label').addClass('no_image');
                }
                src = src.replace('_blue.', '_white.');
                clone.attr('src', src);
                image.addClass('dark');
                clone.addClass('light');
                clone.insertAfter(image);
            });
            let ef;
            eval("ef = $$epiforms");
            if (typeof ef !== 'undefined') {
                ef(".EPiServerForms").on("formsNavigationNextStep formsNavigationPrevStep", function (event, param1, param2) {
                    // Update tips on each step of the form
                    let index = event.targetStep.index;
                    let stepElement = $('[data-f-stepindex="' + index + '"]');
                    let title = stepElement.find('.FormStep__Title').text();
                    let desc = stepElement.find('.FormStep__Description').text();
                    eval("window.parent.updateFormStepTip(index, title, desc)");
                });
            }
            $('[data-tip]').each(function () {
                let tip = $(this);
                let tipId = tip.attr('data-tip');
                let tipValue = tip.attr('data-value');
                let element = tip.closest('.Form__Element ');
                element.addClass('hiddenTip');
                $('.FormChoice__Input--Radio[name="__field_' + tipId + '"][value="' + tipValue + '"]').on('change', tip, function (event) {
                    let title = event.data.find('h3').text();
                    let desc = event.data.find('p').text();
                    let index = event.data.attr('data-tip');
                    eval("window.parent.updateFormStepTip(index, title, desc)");
                    //debugger;
                });
            });
            let title = $('.contentpage-container h3').text();
            let desc = $('.contentpage-container p').text();
            eval("window.parent.updateFormStepTip(-1, title, desc)");
            title = $('.EPiServerForms .Form__Title').text();
            desc = $('.EPiServerForms .Form__Description').text();
            eval("window.parent.updateFormStepTip(0, title, desc)");
        }
        else {
            let fixedContainer = $('<div>').addClass('fixedContainer');
            let formContainer = $('<div>').addClass('formContainer');
            let iframe = $('<iframe>').attr('src', '/perustetaanravintola/lomake').attr('title', 'Perustetaan ravintola perustiedot');
            let closeBubble = $('<div>').addClass('closeBubble')
                .append($('<i class="material-icons close">close</i>'));
            let chatButton = $('<div>').addClass('chatButton')
                .append($('<div>').addClass('bubble').attr('style', 'display:none;')
                .append($('<div>').addClass('intro')
                .append($('<h3>'))
                .append($('<span>')))
                .append($('<div>').addClass('tips').attr('style', 'display:none;')
                .append($('<h3>'))
                .append($('<span>')))
                .append(closeBubble));
            let closeButton = $('<div>').addClass('closeButton')
                .append($('<i class="material-icons close">close</i>'));
            chatButton.on('click', function () {
                $('.fixedContainer').addClass('visible');
                let bubble = $('.bubble');
                bubble.show();
                bubble.find('.intro').hide();
                bubble.find('.tips').show();
                let tipsRead = Cookies.get("tipsRead") || '';
                let tipIds = tipsRead.split(',');
                let index = bubble.attr('data-index');
                if (!isNumber(index)) {
                    bubble.closest('.chatButton').removeClass('unread');
                    if (tipIds.indexOf('' + index) == -1) {
                        tipIds.push(index);
                    }
                    Cookies.set("tipsRead", tipIds.join(','), { path: '/' });
                }
            });
            closeBubble.on('click', function (e) {
                //console.log('hideee');
                $('.bubble').hide();
                e.stopPropagation();
            });
            closeButton.on('click', function () {
                $('.fixedContainer').removeClass('visible');
            });
            fixedContainer.append(formContainer);
            formContainer.append(chatButton);
            formContainer.append(closeButton);
            formContainer.append(iframe);
            fixedContainer.insertBefore('footer');
        }
    }
}
exports.InitPerustetaanRavintola = InitPerustetaanRavintola;
